import { Button, Field, Input } from '@cloudflare/kumo';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ICONS } from '../components/ui/icons';
import { useAppToast } from '../hooks/useAppToast';
import { interactiveCampaignApi } from '../services/interactiveCampaignApi';

export function NovaCampanhaInterativaPage() {
  const navigate = useNavigate();
  const toast = useAppToast();
  const [name, setName] = useState('');
  const [creating, setCreating] = useState(false);

  const handleCreate = async () => {
    if (!name.trim()) {
      toast.error('Informe um nome para a campanha.');
      return;
    }
    try {
      setCreating(true);
      const newCampaign = await interactiveCampaignApi.createCampaign({
        name: name.trim(),
        graph: { nodes: [], edges: [] },
      });
      toast.success('Campanha criada! Configure o fluxo de mensagens.');
      navigate(`/campanhas/interativa/${newCampaign.id}`);
    } catch (error: any) {
      toast.error(`Erro ao criar campanha: ${error.message}`);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div style={{ padding: '28px 40px', background: 'var(--surface-2)', minHeight: '100%' }}>

      {/* Page header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 36 }}>
        <div>
          <h2 className="text-xl font-semibold" style={{ marginBottom: 4, fontSize: 24, fontWeight: 600 }}>
            Nova Campanha Interativa
          </h2>
          <div style={{ color: 'var(--text-muted)' }}>
            Configure o fluxo de mensagens após criar a campanha
          </div>
        </div>
        <Button variant="secondary" icon={ICONS.ArrowLeft} onClick={() => navigate('/campanhas/interativa')}>
          Voltar
        </Button>
      </div>

      {/* Form card */}
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <div style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 8,
          padding: '28px 32px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}>
          <h3 className="text-lg font-semibold" style={{ marginBottom: 8, fontSize: 17 }}>
            Informações da Campanha
          </h3>
          <div style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 24 }}>
            Dê um nome descritivo ao fluxo interativo. Você configurará as mensagens e condições na próxima etapa.
          </div>

          <div style={{ marginBottom: 28 }}>
            <Field label="Nome da Campanha" description="Ex: Fluxo de Boas-vindas, Qualificação de Lead, Suporte Técnico...">
              <Input onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && !creating && handleCreate()} placeholder="Ex: Fluxo de Boas-vindas" value={name} />
            </Field>
          </div>

          {/* Info box */}
          <div style={{
            background: 'var(--tint-blue)',
            border: '1px solid var(--link)',
            borderRadius: 6,
            padding: '10px 14px',
            display: 'flex',
            gap: 10,
            marginBottom: 28,
          }}>
            <ICONS.InfoWithCircle size={16} />
            <div style={{ fontSize: 12, color: 'var(--link)' }}>
              Após criar a campanha, você será redirecionado para o <strong>Flow Builder</strong> onde poderá adicionar mensagens, condições, delays e integrações com IA.
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={() => navigate('/campanhas/interativa')}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleCreate} loading={creating} disabled={!name.trim() || creating}>
              Criar e Configurar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
